import React from 'react';
import Date from '@components/Date';
import { H3 } from '@heading';
import { ArrowLink } from '@input';
import styles from './Card.module.scss';
import classNames from 'classnames';
import { Link } from 'gatsby';

const Card = React.forwardRef(
  (
    {
      title,
      tag,
      isClickable,
      date,
      thumbnail,
      className,
      to,
      linkText,
      children,
      style = {},
      maxWidth,
      thumbnailClassName,
      thumbnailHeight,
      thumbnailStyle,
      onThumbnailClick,
      linkThumbnail = true,
      ...restProps
    },
    ref
  ) => {
    const isLink = isClickable && to;
    const defaultTag = isClickable ? 'button' : 'div';
    const Tag = tag ?? (isLink ? Link : defaultTag);
    const hasContent = title || date || children;

    return (
      <Tag
        to={isLink ? to : null}
        className={classNames(styles.wrapper, className, {
          [styles.clickable]: isClickable
        })}
        style={{ ...style, maxWidth }}
        ref={ref}
        {...restProps}
      >
        <Thumbnail
          content={thumbnail}
          className={thumbnailClassName}
          style={thumbnailStyle}
          height={thumbnailHeight}
          to={linkThumbnail && !isLink && to ? to : null}
          onClick={onThumbnailClick}
        />
        {hasContent && (
          <div className={styles.contentWrapper}>
            <Date value={date} />
            {title && <H3>{title}</H3>}
            {children && <div className={styles.content}>{children}</div>}
          </div>
        )}
        {to && linkText && (
          <div className={styles.linkWrapper}>
            <ArrowLink to={to}>{linkText}</ArrowLink>
          </div>
        )}
      </Tag>
    );
  }
);

export default Card;

function Thumbnail({ content, to, className, style, height, onClick }) {
  const Tag = to ? Link : 'div';
  return !content && !style && !className ? null : (
    <Tag
      to={to}
      style={{ ...style, height }}
      className={classNames(styles.thumbnail, className)}
      onClick={onClick}
    >
      {content}
    </Tag>
  );
}

export function CardsWrapper({
  className,
  style = {},
  maxWidth,
  children,
  ...restProps
}) {
  return (
    <div
      style={{ ...style, maxWidth }}
      className={classNames(styles.cardsWrapper, className)}
      {...restProps}
    >
      {children}
    </div>
  );
}
